import { Typography, message, Button, Row, Col, Space, Card, Input } from "antd";
import { PlusOutlined, DeleteOutlined, CopyOutlined } from "@ant-design/icons";
import PageWrapper from "../../utils/PageWrapper";
import { Users } from "lucide-react";
import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../layout/auth";
import VerificadoresIndex from "./VerificadoresIndex";
import PageTitle from "../../utils/PageTitle";
import VerificadoresEditForm from "./VerificadoresEditForm";

export default function Verificadores() {
  const [inspectors, setInspectors] = useState([]);
  const [filteredInspectors, setFilteredInspectors] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [record, setRecord] = useState({});
  const [search, setSearch] = useState("");

  const auth = useAuth();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/usuarios/getUsuarios`)
      .then((res) => {
        setInspectors(res.data);
      })
      .catch((err) => {
        message.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (search) {
      const filtered = inspectors.filter((inspector) => {
        return (
          inspector?.Nombre?.toString().toLowerCase().includes(search.toLowerCase()) ||
          inspector?.Email?.toString().toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredInspectors(filtered);
    } else {
      setFilteredInspectors(inspectors);
    }
  }, [search, inspectors]);

  return (
    <PageWrapper className="verificadores-main-card">
      <PageTitle icon={<Users />} title="Actividad de los Verificadores" />
      <div
        style={{
          padding: "16px",
          background: "rgba(249, 250, 251, 0.8)",
          borderRadius: "12px",
          border: "1px solid rgba(229, 231, 235, 0.6)",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05)",
          marginBottom: "24px",
        }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Input.Search
              placeholder="Buscar verificador"
              onSearch={(value) => {
                setSearch(value);
              }}
              enterButton="Buscar"
              size="large"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "right" }}>
            {/* No action buttons for now */}
          </Col>
        </Row>
      </div>
      <VerificadoresIndex
        inspectors={search ? filteredInspectors : inspectors}
        setInspectors={setInspectors}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        record={record}
        setRecord={setRecord}
      />
      <VerificadoresEditForm
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        record={record}
        setRecord={setRecord}
        setInspectors={setInspectors}
      />
    </PageWrapper>
  );
}
